import { render, staticRenderFns } from "./ConnectFacebook.vue?vue&type=template&id=6dd7ce7f&"
import script from "./ConnectFacebook.vue?vue&type=script&lang=js&"
export * from "./ConnectFacebook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports